var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{staticStyle:{"height":"calc(100vh - 112px)"},attrs:{"zoom":_vm.zoom,"min-zoom":2,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._l((_vm.markers),function(marker,index){return _c('l-marker',{key:index,attrs:{"lat-lng":[marker.longitude, marker.latitude],"name":marker.name}},[_c('l-tooltip',[_vm._v(" "+_vm._s(marker.name)+" ")])],1)}),_c('l-polygon',{attrs:{"color":"#0099FF","fillColor":"#0099FF","lat-lngs":[
      [50.0669, 19.9059],
      [50.0638, 19.9010],
      [50.0599, 19.9017],
      [50.0566, 19.9005],
      [50.0562, 19.9111],
      [50.0568, 19.9216],
      [50.0601, 19.9228],
      [50.0641, 19.9242],
      [50.0655, 19.9181],
      [50.0657, 19.9105] ]}},[_c('l-tooltip',[_vm._v(" Jeż ")])],1),_c('l-polygon',{attrs:{"color":"#008080","fillColor":"#008080","lat-lngs":[
      [50.0591, 19.9098],
      [50.0568, 19.8962],
      [50.0524, 19.8992],
      [50.0510, 19.9044],
      [50.0513, 19.9119],
      [50.0518, 19.9193],
      [50.0531, 19.9250],
      [50.0564, 19.9275],
      [50.0573, 19.9228],
      [50.0573, 19.9160] ]}},[_c('l-tooltip',[_vm._v(" Sowa ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }